import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { downGradeOfferModalTexts, paths } from 'src/common/config/TextMessage';
import { downGradeOfferModalSxs } from '../newChangePlan';
import { RootState } from 'src/redux/store';
import { useDispatch, useSelector } from 'react-redux';

import { useState } from 'react';
import {
  downgradeDeactivateOffers,
  getAddonDetails,
  getSubscriptionDetailsStripe
} from 'src/common/Scraper';
import CommonAlert from 'src/common/CommonAlert';
import { setProgressCalculation } from 'src/common/config/FunctionHelper';
import {
  setAddonDetails,
  setScanDetails,
} from 'src/redux/counterSlice';
import { setStateStripeSubscription } from 'src/redux/userReducer';
import { useNavigate } from 'react-router';
import { setOfferApplied } from 'src/redux/dashboard';
import { useUserDetails } from 'src/hooks/apiHooks/useUserDetails';

export const NotUsingTheToolAsMuchForNow = ({
  selectedTimeLine = '',
  handCloseModal = () => {},
  handleChangePlanModal = () => {},
  isFromDeactivate = false,
  setIsOfferApplied
}) => {
  const [loading, setLoading] = useState(null);
  const [responseMessage, setResponseMessage]: any = useState(null);
  // subscription details
  let subscription = useSelector((state: RootState) => state.user.subscription);
  let userDetails: any =
    useSelector((state: RootState) => state.counter.userDetails) ?? {};
  let isPremiumUser = useSelector((state: RootState) => state.user.premiumUser);
  const { refetch: refetchUserDetails } = useUserDetails({ enabled: false });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isTrail = subscription?.status == 'trialing';
  const handleRedeemOffer = async () => {
    setLoading(true);
    setIsOfferApplied(true);
    const payload = {
      subscriptionId: subscription?.subscription_id,
      selectedDowngradeReason: 'Not Using The Tool As Much For Now',
      planId: subscription?.plan_name?.id
    };
    const downgradeDeactivateOffersResponse: any =
      await downgradeDeactivateOffers(payload);

    setResponseMessage({
      status: downgradeDeactivateOffersResponse?.status,
      message: downgradeDeactivateOffersResponse?.message
    });
    if (downgradeDeactivateOffersResponse?.status == 'success') {
      const subscriptionDetailsStripe = await getSubscriptionDetailsStripe();
      if (subscriptionDetailsStripe != undefined) {
        dispatch(setStateStripeSubscription(subscriptionDetailsStripe));
      } else {
        dispatch(setStateStripeSubscription({}));
      }
      if (isFromDeactivate) {
        const { data: userDetailsResponse } = await refetchUserDetails();
        if (isPremiumUser) {
          // Fetch additional scan details for premium users
          let addonScan = await getAddonDetails();
          let getProgressScore = setProgressCalculation(
            userDetailsResponse,
            addonScan
          );
          dispatch(setScanDetails(getProgressScore));
          dispatch(setAddonDetails(addonScan));
        }
      }
    }
    setTimeout(() => {
      setLoading(false);
      setIsOfferApplied(false);
      setResponseMessage(null);
      if (downgradeDeactivateOffersResponse?.status == 'success') {
        dispatch(setOfferApplied({ open: true }));
        navigate(paths?.dashboard);
        handCloseModal();
        handleChangePlanModal();
      }
    }, 3000);
  };
  return (
    <>
      <Typography sx={downGradeOfferModalSxs?.offerCardHeadTextSx}>
        {isTrail
          ? downGradeOfferModalTexts?.notUsingDesc7Days
          : downGradeOfferModalTexts?.needBreak}
      </Typography>
      <Typography sx={downGradeOfferModalSxs?.offerCardDescTextSx}>
        {isTrail
          ? downGradeOfferModalTexts?.addSevenDays
          : downGradeOfferModalTexts?.pauseYourSubScription}
      </Typography>
      {responseMessage?.status && (
        <Box className="mt-1">
          <CommonAlert
            severity={responseMessage?.status}
            message={responseMessage?.message}
          />
        </Box>
      )}
      <Button
        variant="contained"
        fullWidth
        onClick={handleRedeemOffer}
        sx={downGradeOfferModalSxs?.offerCardBtnSx}
      >
        {loading ? (
          <CircularProgress color="inherit" size={24} />
        ) : isTrail ? (
          downGradeOfferModalTexts?.redeemOffer
        ) : (
          downGradeOfferModalTexts?.pauseSubscription
        )}
      </Button>
    </>
  );
};
